export interface Breadcrumb {
  title: string;
  routerLink?: string | string[];
}
